import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Grid, IconButton, CircularProgress, Container } from '@mui/material';
import { Edit as EditIcon, Delete as DeleteIcon, Add as AddIcon } from '@mui/icons-material';
import MainLayout from '../layouts/MainLayout';
import { empresaService, Empresa, CreateEmpresaDTO } from '../services/empresaService';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const GerenciarEmpresasPage = () => {
  const [empresas, setEmpresas] = useState<Empresa[]>([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [empresaAtual, setEmpresaAtual] = useState<Empresa | null>(null);
  const [formData, setFormData] = useState<CreateEmpresaDTO>({ nome: '', cnpj: '' });

  const carregarEmpresas = async () => {
    setLoading(true);
    try {
      const data = await empresaService.listar();
      setEmpresas(data);
    } catch (error) {
      toast.error('Erro ao carregar empresas.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarEmpresas();
  }, []);

  const handleOpenDialog = (empresa?: Empresa) => {
    if (empresa) {
      setEmpresaAtual(empresa);
      setFormData({ nome: empresa.nome, cnpj: empresa.cnpj });
    } else {
      setEmpresaAtual(null);
      setFormData({ nome: '', cnpj: '' });
    }
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
    setEmpresaAtual(null);
  };

  const handleSubmit = async () => {
    try {
      if (empresaAtual) {
        await empresaService.atualizar(empresaAtual.id, formData);
        toast.success('Empresa atualizada com sucesso!');
      } else {
        await empresaService.criar(formData);
        toast.success('Empresa criada com sucesso!');
      }
      handleCloseDialog();
      carregarEmpresas();
    } catch (error: any) {
      toast.error(error?.response?.data?.error || 'Erro ao salvar empresa.');
    }
  };

  const handleDelete = async (id: number) => {
    if (window.confirm('Tem certeza que deseja excluir esta empresa?')) {
      try {
        await empresaService.excluir(id);
        toast.success('Empresa excluída com sucesso!');
        carregarEmpresas();
      } catch (error) {
        toast.error('Erro ao excluir empresa.');
      }
    }
  };

  return (
    <MainLayout>
      <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6" component="h2">
              Gerenciar Empresas
            </Typography>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={() => handleOpenDialog()}
            >
              Nova Empresa
            </Button>
          </Box>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Nome</TableCell>
                  <TableCell>CNPJ</TableCell>
                  <TableCell align="right">Ações</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) :
                  empresas.map((empresa) => (
                    <TableRow key={empresa.id}>
                      <TableCell>{empresa.nome}</TableCell>
                      <TableCell>{empresa.cnpj}</TableCell>
                      <TableCell align="right">
                        <IconButton onClick={() => handleOpenDialog(empresa)} color="primary">
                          <EditIcon />
                        </IconButton>
                        <IconButton onClick={() => handleDelete(empresa.id)} color="error">
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                }
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
        <Dialog open={open} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
          <DialogTitle>{empresaAtual ? 'Editar Empresa' : 'Nova Empresa'}</DialogTitle>
          <DialogContent>
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid size={{ xs: 12 }}>
                <TextField
                  fullWidth
                  label="Nome"
                  value={formData.nome}
                  onChange={(e) => setFormData({ ...formData, nome: e.target.value.toUpperCase() })}
                />
              </Grid>
              <Grid size={{ xs: 12 }}>
                <TextField
                  fullWidth
                  label="CNPJ"
                  value={formData.cnpj}
                  onChange={(e) => setFormData({ ...formData, cnpj: e.target.value.toUpperCase() })}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog}>Cancelar</Button>
            <Button onClick={handleSubmit} variant="contained" color="primary">
              Salvar
            </Button>
          </DialogActions>
        </Dialog>
        <ToastContainer />
      </Container>
    </MainLayout>
  );
};

export default GerenciarEmpresasPage; 